// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yXn3OvLs{padding-top:3.94rem}@media(min-width:1366px){.yXn3OvLs{margin-left:8.44rem;margin-right:8.44rem}}.b0K4yXgB{margin-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "yXn3OvLs",
	"item": "b0K4yXgB"
};
module.exports = ___CSS_LOADER_EXPORT___;
